import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2a929129"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "items-center justify-between dark:bg-dark-600 bg-primary-10" }
const _hoisted_2 = { class: "w-full h-full flex flex-col" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { key: 3 }
const _hoisted_7 = { key: 4 }
const _hoisted_8 = {
  key: 5,
  class: "mt-auto"
}
const _hoisted_9 = {
  key: 6,
  class: "mt-auto"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SideMenuButton = _resolveComponent("SideMenuButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      _createElementVNode("li", null, [
        _createVNode(_component_SideMenuButton, {
          icon: 'pie_chart',
          isDisabled: _ctx.leftSideFrame == 'Statistics',
          text: _ctx.$t('message.statistics'),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setLeftSideFrame('Statistics')))
        }, null, 8, ["isDisabled", "text"])
      ]),
      (_ctx.displayLanguage == 'Japanese' && _ctx.get_topicId(_ctx.problemStatePresenter.problemId.value) == 'INFO1')
        ? (_openBlock(), _createElementBlock("li", _hoisted_3, [
            _createVNode(_component_SideMenuButton, {
              icon: 'import_contacts',
              isDisabled: _ctx.leftSideFrame == 'TopicCommentary',
              text: _ctx.$t('message.topicCommentary'),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setLeftSideFrame('TopicCommentary')))
            }, null, 8, ["isDisabled", "text"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.preList.length > 0)
        ? (_openBlock(), _createElementBlock("li", _hoisted_4, [
            _createVNode(_component_SideMenuButton, {
              icon: 'live_help',
              isDisabled: _ctx.leftSideFrame == 'PreCommentary',
              text: _ctx.$t('message.preCommentary'),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setLeftSideFrame('PreCommentary')))
            }, null, 8, ["isDisabled", "text"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("li", null, [
        _createVNode(_component_SideMenuButton, {
          icon: 'description',
          isDisabled: _ctx.leftSideFrame == 'Problem',
          text: _ctx.$t('message.problemDescription'),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setLeftSideFrame('Problem')))
        }, null, 8, ["isDisabled", "text"])
      ]),
      (_ctx.postList.length > 0)
        ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
            _createVNode(_component_SideMenuButton, {
              icon: 'contact_support',
              isDisabled: _ctx.leftSideFrame == 'PostCommentary',
              text: _ctx.$t('message.postCommentary'),
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setLeftSideFrame('PostCommentary')))
            }, null, 8, ["isDisabled", "text"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isLogin)
        ? (_openBlock(), _createElementBlock("li", _hoisted_6, [
            _createVNode(_component_SideMenuButton, {
              icon: 'history',
              isDisabled: _ctx.leftSideFrame == 'History',
              text: _ctx.$t('message.submissionHistory'),
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.setLeftSideFrame('History')))
            }, null, 8, ["isDisabled", "text"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("li", null, [
        _createVNode(_component_SideMenuButton, {
          icon: 'group',
          isDisabled: _ctx.leftSideFrame == 'ModelAnswer',
          text: _ctx.$t('message.modelAnswer'),
          onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setLeftSideFrame('ModelAnswer')))
        }, null, 8, ["isDisabled", "text"])
      ]),
      (_ctx.isLogin)
        ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
            _createVNode(_component_SideMenuButton, {
              id: "review",
              icon: 'reviews',
              isDisabled: _ctx.leftSideFrame == 'Review',
              text: _ctx.$t('message.review'),
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.setLeftSideFrame('Review')))
            }, null, 8, ["isDisabled", "text"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.arenaPresenter.arenaId.value != '' && _ctx.arenaPresenter.arenaProblemIndex.value > 0)
        ? (_openBlock(), _createElementBlock("li", _hoisted_8, [
            _createVNode(_component_SideMenuButton, {
              icon: 'arrow_back',
              text: _ctx.$t('message.prevProblem'),
              onClick: _cache[8] || (_cache[8] = () => _ctx.setPrevArenaProblem())
            }, null, 8, ["text"])
          ]))
        : (_ctx.arenaPresenter.arenaId.value == '' && _ctx.problemStatePresenter.prevProblemId.value != '-1')
          ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
              _createVNode(_component_SideMenuButton, {
                icon: 'arrow_back',
                text: _ctx.$t('message.prevProblem'),
                onClick: _cache[9] || (_cache[9] = () => _ctx.problemStatePresenter.setProblemId(_ctx.problemStatePresenter.prevProblemId.value))
              }, null, 8, ["text"])
            ]))
          : _createCommentVNode("", true)
    ])
  ]))
}